import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import ReadContainer from '@board/containers/ReadContainer.vue'
import api from '@board/api'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'
@Component({
    components: { PageViewHeaderWithActionBar, ReadContainer },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
        })
    }
})
export default class ReadView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    actionOpen: boolean = false
    systemAuth: article.SystemAuth[] = []
    currentBoard: number = 0
    currentArticle: number = 0
    canUpdate: boolean = false
    canDelete: boolean = false
    article: article.ArticleDetail | null = null

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    edit() {
        var { boardId, articleId } = this.$route.query

        this.$router.push({ path: `/board/write?boardId=${boardId}&articleId=${articleId}` });
    }

    deleteItem() {
        (this.$refs.readContainer as any).deleteItem()
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        var { boardId, articleId } = this.$route.query
        if (boardId) this.currentBoard = Number(boardId)
        if (articleId) this.currentArticle = Number(articleId)

        var createPromise: Promise<any>[] = [
            api.article.getArticleDetail(this.currentBoard, this.currentArticle),
            api.article.getSystemAuth(this.currentBoard)
        ]

        Promise.all(createPromise).then(res => {
            this.article = res[0]
            this.systemAuth = res[1]
            this.canUpdate = !this.article?.isNameless && ( this.article?.createdUser === this.User.id || this.systemAuth.findIndex(a => a.update == true || a.isMenuAdmin) >= 0 );
            this.canDelete = !this.article?.isNameless && ( this.article?.createdUser === this.User.id || this.systemAuth.findIndex(a => a.delete == true || a.isMenuAdmin) >= 0 );
        })
    }
}
